export interface RoutesI {
  path: string;
  breadcrumb: string;
}

export const routes: RoutesI[] = [
  { path: "/home", breadcrumb: "Home" },
  { path: "/cycles", breadcrumb: "Cycles Page" },
  { path: "/editableTable", breadcrumb: "Editable table" },
  { path: "/editableTable/:id", breadcrumb: "edit Id" },
  { path: "/viewapplication", breadcrumb: "View Application" },
  { path: "/applicationtype", breadcrumb: "Application Type" },
  { path: "/applicationfiles", breadcrumb: "Application Files" },
  { path: "/supportType", breadcrumb: "Type Of Support" }, //Check text
  { path: "/referenceDataManagement", breadcrumb: "Reference Data Management" },
  { path: "/providers/:id/:userid", breadcrumb: "User Details" },
  { path: "/department/applications/:id/:userid", breadcrumb: "User Details" },
  { path: "/departmentUsers/:userid", breadcrumb: "User Details" },
];
